import styled from "styled-components";
import theme from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-family: roboto;
  margin-right: auto;
  margin-left: 7vw;
  margin-top: 3vh;
  .title {
    font-size: ${theme.fontSize.md};
    font-weight: 600;
    color: black;
  }
  .sub-title {
    font-size: ${theme.fontSize.mm};
    font-weight: 400;
    color: #5f6368;
  }
`;
